export default {
  title: 'DIE SEITE, DIE DU SUCHST, MUSS HIER IRGENDWO SEIN...',
  description: 'Suchst du nach einer der unten erwähnten Seiten?',
  not_found: 'Wir können die eingegebene Url nicht finden. Bitte überprüfe, ob sie korrekt eingegeben wurde.',
  no_restaurants: {
    title: 'Dieser Shop nimmt noch keine Online-Bestellungen an',
    description: 'Schau bald wieder vorbei.',
  },
  toasts: {
    failed_to_load_stores: 'Fehler beim Laden von Store, bitte aktualisiere die Seite',
  },
};
